import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';

/**
 *  FormElementHelp renders the help section to a form element, such as Input, Checkbox, etc
 *
 */
function FormElementHelp(_ref) {
  let {
    help
  } = _ref;
  return !!help && /*#__PURE__*/_jsx("span", {
    "data-cmp": "form-element-help",
    className: "help-block"
  }, "form-element-help", help);
}
export default FormElementHelp;